var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtlasGymOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1a1 1 0 011 1v8a1 1 0 11-2 0V7H1a1 1 0 010-2h1V2a1 1 0 011-1zM6 5a1 1 0 000 2h12a1 1 0 100-2H6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.677 12h4.646a2.002 2.002 0 011.856 1.258l1.741 4.35c.051.12.08.253.08.392v4a1 1 0 11-2 0v-3H8v3a1 1 0 11-2 0v-4c0-.14.029-.272.08-.392l1.74-4.35A2.002 2.002 0 019.677 12zm4.646 2l1.2 3H8.477l1.2-3h4.646z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2a1 1 0 10-2 0v8a1 1 0 102 0V7h1a1 1 0 100-2h-1V2z"
  })));
}
export default SvgAtlasGymOutline;